var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('b-row',[_vm._v(" Welcome "+_vm._s(_vm.currentUser.firstName)+"! ")]),_c('b-row',{staticClass:"icons"},[_c('b-card-group',{attrs:{"deck":""}},[_vm._l((_vm.links),function(link){return [_c('icon-link',{attrs:{"prefix":link.prefix,"icon":link.icon,"title":link.title,"to":link.to}})]})],2)],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }